var _circle, _circle2, _circle3, _g, _path, _g2, _g3, _path2, _g4, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7639,
    cy: 19.9026,
    r: 8.43091,
    fill: "url(#paint0_linear_8643_18091)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7644,
    cy: 19.9025,
    r: 7.86885,
    stroke: "url(#paint1_linear_8643_18091)",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "1 1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8643_18091",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 12,
    width: 16,
    height: 16
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7638,
    cy: 19.9025,
    r: 7.30679,
    fill: "#F3FCF4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8643_18091)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8643_18091)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.7638,
    cy: 19.9025,
    r: 7.30679,
    fill: "url(#paint2_radial_8643_18091)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.8913 27.8774L10.6816 11.8921H12.8653L12.6557 27.8774H10.8913Z",
    fill: "url(#paint3_linear_8643_18091)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.1164 27.7646L3.4834 15.7556L5.37449 14.6638L12.6444 26.8824L11.1164 27.7646Z",
    fill: "url(#paint4_linear_8643_18091)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.9347 26.8822L18.2046 14.6636L20.0956 15.7554L12.4627 27.7644L10.9347 26.8822Z",
    fill: "url(#paint5_linear_8643_18091)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.51172,
    y: 20.7686,
    width: 14.5053,
    height: 6.38668,
    fill: "url(#paint6_linear_8643_18091)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8643_18091)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.7638,
    cy: 19.9025,
    r: 7.30679,
    fill: "#D8D9D9",
    fillOpacity: 0.01
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02384 7.03149H17.5294L20.2075 10.0666L11.7766 11.4718L3.3457 10.0666L6.02384 7.03149Z",
    fill: "url(#paint7_radial_8643_18091)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8643_18091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40425 4.3335H15.149L9.41596 11.0782L3.3457 10.0665L8.40425 4.3335Z",
    fill: "url(#paint8_radial_8643_18091)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0904 4.3335L5.03189 10.3475L3.3457 10.0665L8.40425 4.3335H10.0904Z",
    fill: "url(#paint9_linear_8643_18091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72949 10.7972L9.41568 11.0782L15.1487 4.3335H13.4625L7.72949 10.7972Z",
    fill: "url(#paint10_linear_8643_18091)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8643_18091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1495 4.3335H8.40473L14.1377 11.0782L20.208 10.0665L15.1495 4.3335Z",
    fill: "url(#paint11_radial_8643_18091)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4633 4.3335L18.5218 10.3475L20.208 10.0665L15.1495 4.3335H13.4633Z",
    fill: "url(#paint12_linear_8643_18091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8242 10.7972L14.138 11.0782L8.40501 4.3335H10.0912L15.8242 10.7972Z",
    fill: "url(#paint13_linear_8643_18091)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8643_18091",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 4,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7867 13.3266C11.7867 13.3266 11.7867 13.3266 11.7867 13.3266L11.7868 13.3267C11.7869 13.3267 11.7869 13.3266 11.7869 13.3266C11.7869 13.3266 11.787 13.3265 11.787 13.3265L12.4831 13.0683C13.1138 12.8343 13.3735 12.0824 13.0215 11.5091L11.787 9.4979C11.7869 9.49788 11.7869 9.49786 11.7869 9.49783L11.7869 9.49756C11.7869 9.4975 11.7869 9.49748 11.7868 9.49753C11.7868 9.49757 11.7867 9.49757 11.7867 9.49753L11.7867 9.49752C11.7867 9.49746 11.7866 9.49749 11.7866 9.49755L11.7866 9.49786C11.7866 9.49789 11.7866 9.49792 11.7866 9.49794L10.552 11.5091C10.2001 12.0824 10.4597 12.8343 11.0904 13.0683L11.7866 13.3266C11.7866 13.3266 11.7866 13.3266 11.7866 13.3266C11.7866 13.3266 11.7866 13.3266 11.7866 13.3266L11.7867 13.3266Z",
    fill: "url(#paint14_linear_8643_18091)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8643_18091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7975 13.4067L13.6953 12.6273L11.7975 9.20434L11.7975 13.4067Z",
    fill: "url(#paint15_linear_8643_18091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7973 13.4067L9.89941 12.6273L11.7973 9.20434L11.7973 13.4067Z",
    fill: "url(#paint16_linear_8643_18091)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86023 17.5241C8.90023 16.7241 9.18023 16.1081 9.70023 15.6761C10.2282 15.2361 10.9202 15.0161 11.7762 15.0161C12.3602 15.0161 12.8602 15.1201 13.2762 15.3281C13.6922 15.5281 14.0042 15.8041 14.2122 16.1561C14.4282 16.5001 14.5362 16.8921 14.5362 17.3321C14.5362 17.8361 14.4042 18.2641 14.1402 18.6161C13.8842 18.9601 13.5762 19.1921 13.2162 19.3121V19.3601C13.6802 19.5041 14.0402 19.7601 14.2962 20.1281C14.5602 20.4961 14.6922 20.9681 14.6922 21.5441C14.6922 22.0241 14.5802 22.4521 14.3562 22.8281C14.1402 23.2041 13.8162 23.5001 13.3842 23.7161C12.9602 23.9241 12.4482 24.0281 11.8482 24.0281C10.9442 24.0281 10.2082 23.8001 9.64023 23.3441C9.07223 22.8881 8.77223 22.2161 8.74023 21.3281H10.3722C10.3882 21.7201 10.5202 22.0361 10.7682 22.2761C11.0242 22.5081 11.3722 22.6241 11.8122 22.6241C12.2202 22.6241 12.5322 22.5121 12.7482 22.2881C12.9722 22.0561 13.0842 21.7601 13.0842 21.4001C13.0842 20.9201 12.9322 20.5761 12.6282 20.3681C12.3242 20.1601 11.8522 20.0561 11.2122 20.0561H10.8642V18.6761H11.2122C12.3482 18.6761 12.9162 18.2961 12.9162 17.5361C12.9162 17.1921 12.8122 16.9241 12.6042 16.7321C12.4042 16.5401 12.1122 16.4441 11.7282 16.4441C11.3522 16.4441 11.0602 16.5481 10.8522 16.7561C10.6522 16.9561 10.5362 17.2121 10.5042 17.5241H8.86023Z",
    fill: "url(#paint17_linear_8643_18091)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8643_18091",
    x: 4.45703,
    y: 12.5957,
    width: 14.6133,
    height: 14.6135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.101961 0 0 0 0 0.105882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8643_18091"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8643_18091",
    x: 4.45703,
    y: 12.5957,
    width: 14.6133,
    height: 14.6135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.231373 0 0 0 0 0.12549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8643_18091"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8643_18091",
    x: 3.3457,
    y: 0.333496,
    width: 19.8037,
    height: 14.7446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8643_18091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8643_18091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8643_18091",
    x: 0.404297,
    y: 0.333496,
    width: 19.8037,
    height: 14.7446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8643_18091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8643_18091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8643_18091",
    x1: 6.11521,
    y1: 13.4951,
    x2: 16.6539,
    y2: 26.7878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BBBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8643_18091",
    x1: 6.49223,
    y1: 13.9222,
    x2: 16.3283,
    y2: 26.3288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176138"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8643_18091",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.7638 19.9025) rotate(90) scale(7.30679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8643_18091",
    x1: 11.7735,
    y1: 11.8921,
    x2: 11.7735,
    y2: 27.8774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8643_18091",
    x1: 5.51143,
    y1: 16.2922,
    x2: 11.8804,
    y2: 27.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8643_18091",
    x1: 18.0676,
    y1: 16.292,
    x2: 11.6986,
    y2: 27.3233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8643_18091",
    x1: 11.7644,
    y1: 23.538,
    x2: 11.7443,
    y2: 26.7597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176138"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_8643_18091",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.7766 9.25163) rotate(90) scale(2.22014 8.43091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_8643_18091",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.24734 7.70586) rotate(90) scale(3.37237 5.90164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8643_18091",
    x1: 4.45858,
    y1: 5.05518,
    x2: 8.09802,
    y2: 10.2035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BBBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8643_18091",
    x1: 8.95366,
    y1: 5.14286,
    x2: 13.061,
    y2: 10.8417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BBBC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_8643_18091",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3064 7.70586) rotate(90) scale(3.37237 5.90164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8643_18091",
    x1: 19.0951,
    y1: 5.05518,
    x2: 15.4557,
    y2: 10.2035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BBBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8643_18091",
    x1: 14.6001,
    y1: 5.14286,
    x2: 10.4927,
    y2: 10.8417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BBBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8643_18091",
    x1: 11.9255,
    y1: 10.5376,
    x2: 10.5794,
    y2: 11.9943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8643_18091",
    x1: 13.3822,
    y1: 12.9024,
    x2: 11.0618,
    y2: 11.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BBBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8643_18091",
    x1: 10.2126,
    y1: 12.9024,
    x2: 12.5329,
    y2: 11.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BBBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8643_18091",
    x1: 9.72231,
    y1: 16.0976,
    x2: 15.4121,
    y2: 20.8374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BBBC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.c052ff408772e1b834310473d120cde8.svg";
export { ForwardRef as ReactComponent };